module.exports = __webpack_public_path__ + "static/media/project4.00953f84.jpg";